import get from 'lodash/get';
import capitalize from 'lodash/capitalize';

const getString = (key, code) => `${capitalize(key)} ${code}`;

export default errorObj => {
  const validationErrors = get(errorObj, ['meta', 'validationErrors']);

  return (
    validationErrors &&
    Object.keys(validationErrors).reduce((acc, key) => {
      const entity = validationErrors[key];

      if (entity) {
        if (Array.isArray(entity)) {
          entity.forEach(error => acc.push(getString(key, error.code)));
        } else {
          acc.push(getString(key, entity));
        }
      }

      return acc;
    }, [])
  );
};



// WEBPACK FOOTER //
// ./src/utils/handleApiError/index.js